// extracted by mini-css-extract-plugin
export var indeterminate = "_1q-5";
export var md = "_1q-4";
export var semantic = "_1q-6";
export var sm = "_1q-3";
export var text = "_1q-7";
export var toggleInput = "_1q-0";
export var toggleSwitch = "_1q-1";
export var xs = "_1q-2";